<template>
  <div class="promo-header">
    <div class="promo-header__wrap">
      <div v-if="isUserInProject" class="promo-header__login">
        <img class="promo-header__login-icon" :src="userAuthIcon">
        {{ user.nickname }}
      </div>
      <button v-else class="promo-header__auth" @click="handleButtonClick">{{ $t("header.login") }}</button>
    </div>
  </div>
</template>

<script>
import UserMixin from "@godweb/frontend-base/src/mixins/user/UserMixin";
import env from "@godweb/frontend-base/src/libs/tools/Environment";

export default {
  name: "PromoHeader",
  mixins: [UserMixin],
  computed: {
    userAuthIcon() {
      return require(`../images/auth-methods/${this.user.origin}.svg`);
    },
  },
  watch: {
    isUserInProject: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          const locale = env.getPosixLocale(this.$i18n.locale)
          this.$api.accountService.locale(locale).run();
        }
      },
    },
  },
  methods: {
    handleButtonClick() {
      this.$oneLinkEventSender.sendEvent("login");
      this.changeAccount();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/promo-header";
</style>
